<template>
    <div class="container">
        <div class="content">
            <div class="forms">
                <el-form :inline="true" :model="form" ref="form" class="search-form" size="small" label-width="84px">
                    <el-form-item label="考勤组名称">
                        <el-input  class="inline-input" v-model="form.name"  placeholder="请输入内容" 
                        clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div style="display: flex;">
                            <div class="s-btn" @click="fetchData('search')">查询</div>
                            <div class="r-btn" @click="fetchData('reset')">重置</div>
                        </div>
                    </el-form-item>

                </el-form>
                <div class="line"></div>
                <div class="data-title">
                    <div style="display: flex;height: 32px;">
                        <div class="title-line"></div>
                        <div class="title-name">数据列表</div>
                    </div>
                </div>
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.pageTotal"
                    layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10,20,30,50,200,2000]"
                    :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange" v-loading="loading">
                </lb-table>
            </div>
        </div>
    </div>
</template>
<script>
import eldate from "@/components/eldate.vue";
import LbTable from "@/components/lb-table/lb-table";
export default {
    name: "attendanceManagementScheduleList",
    components: {  eldate, LbTable },
    data() {
        return {
            form: {
                name: '', 

            },
            page: {
                pageNo: 1,
                pageSize: 10,
                pageTotal:0,
            },
            list: [],
            loading:false,
            totalNum: 0,
            parArray: [],
            columns: [
                { label:'序号', type: 'index', width: '80' },
                { label: '考勤组名称', prop: 'name', minWidth: '200',
                    render: (h, scope) => {
                        return (
                            <div class='align-left'>
                                { scope.row.groupName}
                            </div>
                        )
                    }
                },
                { label:'人数', prop: 'id', width: '120',
                  render: (h, scope) => {
                        return (
                            <div class='align-left'>{scope.row.memberCount || 0}</div>
                        )
                    }
                 },
                { label: '考勤时间', prop: 'createdTime', minWidth: '160',
                    render: (h, scope) => {
                       const shiftListTime = scope.row.shiftListTime || '-'
                        return (
                            <div class='align-left'>
                                {shiftListTime.split('\n').map((item, index) => (
                                    <div key={index}>{item}</div>
                                ))}
                            </div>
                        )
                    }
                },
                {
                    label: '操作', prop: 'orgName', width: '80', fixed: 'right',
                    render: (h, scope) => {
                        const editButton = <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.onDetail(scope.row, scope.$index) }} >排班</div>
                        const vv = (<div style="display:flex;">
                            {this.parArray.includes('set_schedule') && scope.row.canSchedule ? editButton : ''}
                        </div >)
                        return vv
                    }
                },
            ]
        }
    },
    activated() {
        let id = this.$route.query.id
        this.fetchData(id);
    },
    created() {
        // 权限设定判断 
        const limits = JSON.parse(sessionStorage.getItem("limit"))
        const params = limits.buttonTreeDto.find(
            (item) => item.menuCode === "attendanceManagementSchedule"
        )
        params && params.buttonList.forEach((item) => {
            this.parArray.push(item.code)
        })
    },
    methods: {

        fetchData(type) {
            if (type == 'reset') {
                this.form = {
                    name: '',
                }
                this.page = {
                    pageNo: 1,
                    pageSize: 10,
                    pageTotal:0,
                }
            }
            if (type == 'search') {
                this.form.pageNo = 1
            }
             this.form.pageNo = this.page.pageNo
            this.form.pageSize = this.page.pageSize
            console.log('>>',this.form)
            this.loading = true
            this.$api.scheduleList(this.form).then(res => {
                if (res.code == 0) {
                    const data = res.data || {}
                    let list = data.records || []
                    list.forEach(item => {
                        item.shiftListTime = (item.shiftSummaries || [])
                            .map(shift => `${shift.name}  ${shift.timeRange}`)
                            .join('\n')
                    })
                    this.list = list
                    this.page.pageTotal = data.total
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
                this.loading = false
            })
        },
       
        handleSizeChange(e) {
            this.page.pageSize = e
            this.fetchData()
        },
        handleCurrentChange(e) {
            this.page.pageNo = e
            this.fetchData()
        },
         onMultipleSelection(val) {
            // if (val.length == this.page.pageSize) {
            //     this.form.allFlag = 1
            // }
            if (val) {
                this.form.ids = val.map((item) => {
                    return item.id
                })
            }

        },
        onDetail(val) {
            this.$router.push({ name: 'attendanceManagementScheduleDetail', query: { id: val.groupId } })
        },
        
    }

}
</script>
<style lang="scss" src="@/pages/attendanceManagement/common/style/common.scss" scoped />